import { render } from "./UserIndexView.vue?vue&type=template&id=882b4184"
import script from "./UserIndexView.vue?vue&type=script&lang=js"
export * from "./UserIndexView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\服务器\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__